import { z } from "zod";
import { zStringId } from "../../utils";

// const zServiceRequirements = z.object({
//   question: z.string().optional(),
//   answerType: z.object({
//     type: z.enum(["freeText", "multipleChoice", "file"]),
//     multipleChoice: z.object({
//       choice: z.string().array(),
//       allowMoreAnswers: z.boolean(),
//     }),
//   }),
//   required: z.boolean().optional(),
// });

export function zServiceDescriptiveFields() {
  return {
    title: z.string(),
    description: z.string().optional(),
    images: z.string().array(),
    questionnaire: z
      .object({
        question: z.string().optional(),
        answer: z.string().optional(),
      })
      .array(),
    category: z.object({
      id: zStringId().optional(),
      name: z.string().optional(),
      icon: z.string().optional(),
    }),
    subCategory: z.object({
      id: zStringId().optional(),
      name: z.string().optional(),
    }),
    skills: z.string().array(),
  };
}

// TODO: Complete
// export const zService = z.object({ ...zServiceDescriptiveFields() });
